<template>
  <div class="search-form">
  </div>
</template>

<script>
// 初始表单
const initForm = {
}

export default {
  data() {
    return {
      form: {...initForm},
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {...initForm}
    },
  },
}
</script>
